// extracted by css-extract-rspack-plugin
export default {"root":"cOHwni","llama":"M3m9Jt","big":"nNRYd4","small":"n4bL_p"};